import React from "react";
import {
  Box,
  Typography,
  Stack,
  Avatar,
  Divider,
} from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

const YogaSelfSection = () => {
  const features = [
    {
      icon: <SchoolIcon sx={{ color: "#8b5cf6" }} />,
      bgColor: "#ede9fe",
      title: "Expert Instructors",
      desc: "Whether you're a beginner or an experienced yogi, our expert instructors are here to guide and support you.",
    },
    {
      icon: <AutoAwesomeIcon sx={{ color: "#10b981" }} />,
      bgColor: "#d1fae5",
      title: "Transformative Power of Yoga",
      desc: "Experience the harmony between body and mind through our holistic yoga programs designed for all levels.",
    },
    {
      icon: <PeopleAltIcon sx={{ color: "#06b6d4" }} />,
      bgColor: "#cffafe",
      title: "Welcoming Community",
      desc: "Join a warm and inclusive community where everyone supports each other on their wellness journey.",
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 6, md: 15 },
        px: { xs: 2, md: 8 },
        bgcolor: "#fff",
        fontFamily: "Poppins, sans-serif",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "start",
        justifyContent: "space-between",
        gap: 6,
      }}
    >
      {/* Left Side - Text Section */}
      <Box
        sx={{
          flex: "1 1 50%",
          width: { xs: "100%", md: "50%" },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            mb: 8,
            textAlign:"start",
            fontSize: { xs: "1.8rem", md: "2.2rem" },
            color: "#111",
          }}
        >
          Your Life For Greater Self Of Yoga
        </Typography>

       <Stack spacing={3} divider={<Divider sx={{ borderColor: "#e0e0e0", }} />}>
  {features.map((item, index) => (
    <Stack
      direction="row"
      alignItems="flex-start"
      spacing={2}
      key={index}
      sx={{ pb: index !== features.length - 1 ? 2 : 0,}}
    >
      <Avatar
        sx={{
          bgcolor: item.bgColor,
          width: 50,
          height: 50,
        }}
      >
        {item.icon}
      </Avatar>

      <Box>
        <Typography
          variant="h6"
          sx={{ textAlign: "start", color: "#111", mb: 0.5 }}
        >
          {item.title}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#666", textAlign: "start", lineHeight: 1.6 }}
        >
          {item.desc}
        </Typography>
      </Box>
    </Stack>
  ))}
</Stack>
        
      </Box>

      {/* Right Side - Image Section */}
      <Box
        sx={{
          flex: "1 1 60%",
          width: { xs: "100%", md: "50%" },
          display: "flex",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <Box
          component="img"
          src="/images/self.jpeg"
          alt="Yoga Practice"
          sx={{
            width: 700,
            height:600,
            borderRadius: "20px",
            objectFit: "cover",
          }}
        />
      </Box>
    </Box>
  );
};

export default YogaSelfSection;
